import { motion } from 'motion/react';
import styles from './FileEnlarged.module.css';

export default function FileEnlarged({ src, onClose }) {
    return (
        <motion.div
            className={styles.enlarged}
            onClick={onClose}
            initial={{ scale: .5 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{ duration: .2 }}
            style={{ pointerEvents: 'auto' }}
        >
            <motion.div
                className={styles.enlargedInner}
                onClick={(e) => e.stopPropagation()}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ delay: .25 }}
            >
                <div className={styles.enlargedClose} onClick={onClose} style={{ cursor: 'pointer' }}>
                    <i className='far fa-xmark' style={{ pointerEvents: 'none' }} />
                </div>
                <div className={styles.imgWrap}>
                    <motion.img
                        src={src || null}
                        width='auto'
                        height='auto'
                        className={`${styles.enlargedImg} ${styles.active}`}
                        alt='enlarged'
                        initial={{ scale: .2 }}
                        animate={{ scale: 1 }}
                        exit={{ scale: 0 }}
                        transition={{ type: 'spring', stiffness: 200, damping: 15 }}
                        style={{ originX: '50%', originY: '50%' }}
                    />
                </div>
            </motion.div>
        </motion.div>
    );
}